export default __webpack_public_path__ + "static/media/bghero.ca14795b.png";